module.exports = __webpack_public_path__ + "img/icon_map_5_yj_hg.b617864d.png";